<template>
  <div class="asc-airline-mgmt-grid">
    <asc-ag-grid-filter
      :key="`asc-analytic-grid_${gridId}`"
      :grid-options="agGridOptions"
      :column-defs="getGridColumnDefs"
      :row-data="agGridRowData"
    ></asc-ag-grid-filter>
  </div>
</template>

<script>
import {
  AscAgGridFilter,
  AscAgGridAutocompleteFloatFilter,
  AscAgGridDateFloatFilter,
  AscDrillDownCellRenderer,
  AscDrillDownReadCellRenderer,
  AscTooltipCellRenderer,
} from '@/components/agGrid'
import { AscGridPropsMixin, AscGridMethodsMixin } from '@/components/mixins'
import { stringTextMatcher } from '@/components/agGrid/AgGridHelperMethods'
import { getFilterOptions } from '@/components/agGrid/AgGridOptions'

export default {
  name: 'AscAirlineMgmtGrid',

  components: {
    AscAgGridFilter,
    AscAgGridAutocompleteFloatFilter,
    AscAgGridDateFloatFilter,
    AscDrillDownCellRenderer,
    AscDrillDownReadCellRenderer,
    AscTooltipCellRenderer,
  },

  mixins: [AscGridPropsMixin, AscGridMethodsMixin],

  props: {
    addAirline: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onOpen: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      agGridOptions: getFilterOptions(this, {
        defaultColDef: {
          tooltipComponent: 'AscTooltipCellRenderer',
        },
        rowSelection: 'single',

        onGridReady: this.handleGridReady,
        onFirstDataRendered: this.handleFirstDataRendered,
        onGridSizeChanged: this.handleGridSizeChanged,
        onCellClicked: this.handleCellClicked,
      }),
    }
  },

  computed: {
    mappedValues() {
      return this.values
    },
    agGridRowData() {
      this.resetLocalStorage(this.localStorageName)
      return this.mappedValues
    },
    getGridColumnDefs() {
      return [
        {
          headerName: 'ID',
          field: 'id',
          filter: 'agNumberColumnFilter',
        },
        {
          headerName: 'Airline',
          field: 'name',
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: stringTextMatcher,
          },
          floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
          floatingFilterComponentParams: {
            ids: [],
            items: this.getUniqueItems('name'),
            suppressFilterButton: true,
          },
        },
        {
          headerName: 'ICAO',
          field: 'icaoCode',
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: stringTextMatcher,
          },
          floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
          floatingFilterComponentParams: {
            ids: [],
            items: this.getUniqueItems('icaoCode'),
            suppressFilterButton: true,
          },
        },
        {
          headerName: 'Tail Count',
          field: 'tailCount',
          filter: 'agNumberColumnFilter',
        },
        {
          headerName: 'Active',
          field: 'isActive',
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: stringTextMatcher,
          },
          floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
          floatingFilterComponentParams: {
            ids: [],
            items: [
              { text: 'Yes', value: 1 },
              { text: 'No', value: 2 },
            ],
            suppressFilterButton: true,
          },
          valueGetter: value => (value.data.isActive ? 'Yes' : 'No'),
        },
      ]
    },
  },

  methods: {
    handleCellClicked(event) {
      if (event) {
        this.onOpen(event.data)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-sort-icon {
  color: $primary_black;
  position: absolute;
  top: 14px;
  right: 16px;
}

.asc-filter-icon {
  color: $primary_black;
}

.asc-airline-mgmt-grid--button {
  padding: 10px 0;
}
</style>
